export const numMaxItemPerSession = 50;
